import React, { useState } from 'react';
import { Menu, X, Mail, Phone } from 'lucide-react';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className="fixed w-full z-50">
      {/* Top Bar - Corporate Blue */}
      <div className="bg-primary text-white py-2 text-xs md:text-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center text-center md:text-left space-y-1 md:space-y-0">
          <div className="flex flex-col md:flex-row md:items-center md:space-x-6 space-y-1 md:space-y-0">
            <div className="flex items-center justify-center md:justify-start">
              <Mail className="h-3 w-3 md:h-4 md:w-4 mr-2" />
              <span>administracion@aresglobalcontrol.com</span>
            </div>
            <div className="flex items-center justify-center md:justify-start">
              <Phone className="h-3 w-3 md:h-4 md:w-4 mr-2" />
              <span>+34 636 39 95 50</span>
            </div>
          </div>
          <div className="text-gray-200 text-xs hidden md:block">
            Servicio profesional 24h
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16 md:h-20"> {/* Standard height mobile, taller desktop */}
            <div className="flex items-center">
              <div className="flex-shrink-0 flex items-center">
                <img src="/logo-ares.png" alt="ARES Global Control Logo" className="h-10 md:h-12 w-auto" onError={(e) => {
                  e.currentTarget.src = 'https://via.placeholder.com/40?text=ARES'; 
                }} />
                <span className="ml-3 text-lg md:text-xl font-extrabold text-primary tracking-tight">ARES GLOBAL CONTROL</span>
              </div>
            </div>
            <div className="hidden md:flex items-center space-x-8">
              <a href="#inicio" className="text-gray-600 hover:text-primary px-3 py-2 rounded-md text-sm font-medium transition-colors border-b-2 border-transparent hover:border-primary">Inicio</a>
              <a href="#servicios" className="text-gray-600 hover:text-primary px-3 py-2 rounded-md text-sm font-medium transition-colors border-b-2 border-transparent hover:border-primary">Servicios</a>
              <a href="#valores" className="text-gray-600 hover:text-primary px-3 py-2 rounded-md text-sm font-medium transition-colors border-b-2 border-transparent hover:border-primary">Valores</a>
              <a href="#galeria" className="text-gray-600 hover:text-primary px-3 py-2 rounded-md text-sm font-medium transition-colors border-b-2 border-transparent hover:border-primary">Galería</a>
              <a href="#contacto" className="bg-primary text-white px-5 py-2.5 rounded-full text-sm font-medium hover:bg-blue-900 shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-0.5">Contacto</a>
            </div>
            <div className="-mr-2 flex md:hidden items-center">
              <button
                onClick={toggleMenu}
                type="button"
                className="bg-gray-50 inline-flex items-center justify-center p-2 rounded-md text-primary hover:text-blue-900 hover:bg-gray-100 focus:outline-none"
                aria-controls="mobile-menu"
                aria-expanded="false"
              >
                <span className="sr-only">Abrir menú</span>
                {isOpen ? <X className="block h-6 w-6" /> : <Menu className="block h-6 w-6" />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden bg-white border-t" id="mobile-menu">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              <a href="#inicio" className="text-gray-700 hover:text-primary hover:bg-gray-50 block px-3 py-2 rounded-md text-base font-medium" onClick={toggleMenu}>Inicio</a>
              <a href="#servicios" className="text-gray-700 hover:text-primary hover:bg-gray-50 block px-3 py-2 rounded-md text-base font-medium" onClick={toggleMenu}>Servicios</a>
              <a href="#valores" className="text-gray-700 hover:text-primary hover:bg-gray-50 block px-3 py-2 rounded-md text-base font-medium" onClick={toggleMenu}>Valores</a>
              <a href="#galeria" className="text-gray-700 hover:text-primary hover:bg-gray-50 block px-3 py-2 rounded-md text-base font-medium" onClick={toggleMenu}>Galería</a>
              <a href="#contacto" className="text-primary font-bold block px-3 py-2 rounded-md text-base bg-blue-50 mt-4" onClick={toggleMenu}>Contacto</a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
